
import { defineComponent } from 'vue';
import { adService } from '../AdService';
import store from '@/store';
import { googleTagManagerService } from '@/shared/services/GoogleTagManagerService';
import config from '@/shared/constants/config';

export default defineComponent({
  name: 'AdListItemLike',
  props: {
    ad: {
      type: Object,
      required: true,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isLoggedIn() {
      return store.getters['isLoggedIn'];
    },
  },
  data() {
    return {
      isEstateAgencyMode: config.IS_ESTATE_AGENCY_MODE,
      isLoginModalVisible: false,
    };
  },
  methods: {
    showLoginModal() {
      this.isLoginModalVisible = true;
    },
    closeLoginModal() {
      this.isLoginModalVisible = false;
    },
    async like() {
      if (!this.isLoggedIn) {
        this.showLoginModal();
        return;
      }
      googleTagManagerService.send({
        event: 'Like-click',
      });
      if (this.ad.isLike) {
        const result = await adService.unlike(this.ad.adId);
        if (result.status === 200) {
          this.ad.isLike = false;
          this.ad.likeCount = result.data.count;
        }
      } else {
        const result = await adService.like(this.ad.adId);
        if (result.status === 200) {
          this.ad.isLike = true;
          this.ad.likeCount = result.data.count;
        }
      }
    },
  },
});
